// Generated on 2025-12-23T21:59:22.887Z
// This file contains preloaded vehicles brands data from the API
// Do not edit manually - use 'npm run generate:vehicles-brands-data' to regenerate

export const preloadedVehiclesBrands: any = [
  {
    "marca": "TOYOTA",
    "busquedas": "129376"
  },
  {
    "marca": "HONDA",
    "busquedas": "124941"
  },
  {
    "marca": "FORD",
    "busquedas": "103812"
  },
  {
    "marca": "HYUNDAI",
    "busquedas": "63476"
  },
  {
    "marca": "NISSAN",
    "busquedas": "57394"
  },
  {
    "marca": "KIA",
    "busquedas": "32934"
  },
  {
    "marca": "MITSUBISHI",
    "busquedas": "29802"
  },
  {
    "marca": "MAZDA",
    "busquedas": "18907"
  },
  {
    "marca": "CHEVROLET",
    "busquedas": "17532"
  },
  {
    "marca": "JEEP",
    "busquedas": "16641"
  },
  {
    "marca": "ISUZU",
    "busquedas": "9563"
  },
  {
    "marca": "PONTIAC",
    "busquedas": "5825"
  },
  {
    "marca": "BMW",
    "busquedas": "4174"
  },
  {
    "marca": "DODGE",
    "busquedas": "3614"
  },
  {
    "marca": "VOLKSWAGEN",
    "busquedas": "2771"
  },
  {
    "marca": "SUZUKI",
    "busquedas": "2620"
  },
  {
    "marca": "SCION",
    "busquedas": "1042"
  },
  {
    "marca": "ACURA",
    "busquedas": "941"
  },
  {
    "marca": "GMC",
    "busquedas": "825"
  },
  {
    "marca": "SUBARU",
    "busquedas": "823"
  },
  {
    "marca": "RAM",
    "busquedas": "819"
  },
  {
    "marca": "MINI",
    "busquedas": "811"
  },
  {
    "marca": "MERCURY",
    "busquedas": "550"
  },
  {
    "marca": "LEXUS",
    "busquedas": "416"
  },
  {
    "marca": "CHRYSLER",
    "busquedas": "365"
  },
  {
    "marca": "MERCEDES-BENZ",
    "busquedas": "335"
  },
  {
    "marca": "VOLVO",
    "busquedas": "278"
  },
  {
    "marca": "AUDI",
    "busquedas": "217"
  },
  {
    "marca": "SATURN",
    "busquedas": "206"
  },
  {
    "marca": "HUMMER",
    "busquedas": "204"
  },
  {
    "marca": "INFINITI",
    "busquedas": "203"
  },
  {
    "marca": "GEO",
    "busquedas": "145"
  },
  {
    "marca": "CADILLAC",
    "busquedas": "129"
  },
  {
    "marca": "LAND ROVER",
    "busquedas": "120"
  },
  {
    "marca": "LINCOLN",
    "busquedas": "116"
  },
  {
    "marca": "PORSCHE",
    "busquedas": "104"
  },
  {
    "marca": "FIAT",
    "busquedas": "44"
  },
  {
    "marca": "PLYMOUTH",
    "busquedas": "40"
  },
  {
    "marca": "BUICK",
    "busquedas": "37"
  },
  {
    "marca": "RENAULT",
    "busquedas": "32"
  },
  {
    "marca": "DAIHATSU",
    "busquedas": "31"
  },
  {
    "marca": "JAGUAR",
    "busquedas": "29"
  },
  {
    "marca": "DAEWOO",
    "busquedas": "20"
  },
  {
    "marca": "JMC",
    "busquedas": "13"
  },
  {
    "marca": "JAC",
    "busquedas": "6"
  },
  {
    "marca": "MASERATI",
    "busquedas": "6"
  },
  {
    "marca": "JIM",
    "busquedas": "5"
  },
  {
    "marca": "PEUGEOT",
    "busquedas": "5"
  },
  {
    "marca": "MAHINDRA",
    "busquedas": "5"
  },
  {
    "marca": "EAGLE",
    "busquedas": "2"
  },
  {
    "marca": "DATSUN",
    "busquedas": "2"
  },
  {
    "marca": "CHERY",
    "busquedas": "2"
  },
  {
    "marca": "LAMBORGHINI",
    "busquedas": "1"
  },
  {
    "marca": "MAXUS",
    "busquedas": "1"
  },
  {
    "marca": "ASTON MARTIN",
    "busquedas": "1"
  },
  {
    "marca": "TESLA",
    "busquedas": "1"
  }
];

export default preloadedVehiclesBrands;
